import type {
  CreateNewOrderRequestBody,
  CreateNewOrderResponse,
  DefaultQueryError,
} from '@ahm/api-wrappers-core';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { createOrderPartnerFn } from './create-order-partner-fn';

export const useCreateOrderPartner = (
  opts?: Omit<
    UseMutationOptions<
      CreateNewOrderResponse,
      DefaultQueryError,
      CreateNewOrderRequestBody
    >,
    'mutationFn'
  >
) =>
  useMutation<
    CreateNewOrderResponse,
    DefaultQueryError,
    CreateNewOrderRequestBody
  >({
    mutationKey: ['createOrderPartnerFn'],
    mutationFn: createOrderPartnerFn,
    ...opts,
  });
